import template from '../../../templates/Stones/AssignPricing/footer.rt';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from '../../../actions';
import {AccessRights} from '../../../schemas/accessRightsModel';
import { showClonePricingPresetsIntoPopup } from '../../../actions/A_Popups';

const mapStateToProps = function (state) {
  return {
    updateItemCount: actions.getItemUpdateCount(state.editor),
    AR: AccessRights.get(state)
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onSave: () => dispatch(actions.savePendingUpdates()),
    onCancel: () => dispatch(actions.cancelPendingUpdates()),
    showPricingPresetList: () => dispatch(actions.pricingPresets.show(true)).catch(console.error),
    fetchStones: () => dispatch(actions.loadAndFetchStones()),
    showClonePricingPresetsIntoPopup: config => dispatch(showClonePricingPresetsIntoPopup(config)),
  }
};

class footer extends React.Component {
  render = template;

  constructor() {
    super();
    this.state = {
      showCancelMessage: false
    };
  }

  onSave = () => {
    this.props.onSave()
      .then(this.props.fetchStones);
  }

  /**
   * Returns button array for cancel changes
   * @returns {[{text, subtext, onClick}, ...]}
   */
  getCancelButtons = () => {
    return [{
      text: 'Yes',
      subtext: 'I want to cancel and lose all unsaved changes',
      onClick: () => {
        this.props.onCancel(this.props.state);
        this.setState({showCancelMessage: false});
      }
    },
      {
        text: 'No',
        subtext: 'I want to keep my unsaved changes',
        onClick: function () {
          this.setState({showCancelMessage: false});
        }.bind(this)
      }];
  }

  showCloneIntoDialog = (show = true) => {
    this.props.showClonePricingPresetsIntoPopup({visible: show});
  }
}

footer.propTypes = {
  updateItemCount: PropTypes.number.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const Footer = connector(footer);

export default Footer;
